/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_InactiveInputs */

const cs_settings_teams_inactive = /** @type {(inputs: Settings_Teams_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neaktivní`)
};

const en_settings_teams_inactive = /** @type {(inputs: Settings_Teams_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactive`)
};

/**
* | output |
* | --- |
* | "Inactive" |
*
* @param {Settings_Teams_InactiveInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_inactive = /** @type {((inputs?: Settings_Teams_InactiveInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_InactiveInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_inactive(inputs)
	return cs_settings_teams_inactive(inputs)
});